import React from 'react';
import Skeleton from 'react-loading-skeleton';
import _ from 'lodash';

import 'react-loading-skeleton/dist/skeleton.css';

const WidgetSkeletonNotification = () => {
  const random = _.random(20, 75);

  return (
    <div className="notification-wrapper notification-skeleton">
      <div className="notification-avatar">
        <Skeleton circle={true} style={{ width: 40, height: 40, marginRight: 10 }} />
      </div>
      <div className="notification-content">
        <div className="notification-header">
          <span><Skeleton style={{ width: `${random}%` }} /></span>
          <div className="notification-header-properties">
            <Skeleton />
          </div>
        </div>
        <div className="notification-subheader">
          <Skeleton style={{ width: `${random}%` }} />
        </div>
      </div>
    </div>
  );
};

export default WidgetSkeletonNotification;
